<template>
    <div class="map">
        <div class="map-box">
            <!-- <div> -->
            <Map2D v-if="changeMapBtn == 2" />
            <Map3D v-if="changeMapBtn == 3" />
            <!-- </div> -->
        </div>
        <topTitle class="top-title" :title="'移动能源运营监控调度大屏'"></topTitle>
        <!-- <span
            class="switch-map"
            :class="{'map-3d': changeMapBtn == 2}"
            @click="changeMapBtn = changeMapBtn == 2 ? 3 : 2">
        </span> -->
        <div class="content">
            <div class="map-left">
                <mapLeft></mapLeft>
            </div>
            <div class="map-center">
                <mapCenter :number="'123123132'.split('')"></mapCenter>
            </div>
            <div class="map-right">
                <mapRight></mapRight>
            </div>
        </div>
    </div>
</template>

<script>
import Map2D from "../components/2dmap.vue";
import Map3D from '../components/mars3d/3dMap.vue'

import topTitle from '../components/topTitle.vue'
import mapLeft from './mapComponents/left.vue'
import mapCenter from './mapComponents/center.vue'
import mapRight from './mapComponents/right.vue'
export default {
    components: {
        topTitle,
        mapLeft,
        mapCenter,
        mapRight,
        Map2D,
        Map3D
    },
    data() {
        return {
            changeMapBtn: null
        }
    },
    mounted() {
        setTimeout(() => {
            this.changeMapBtn = 2
        }, 2000);
    }
}
</script>

<style lang="scss" scoped>
.map {
    .top-title {
        position: relative;
    }
    .map-box {
        position: absolute;
        width: 100%;
        height: 100%;
        padding-bottom: 50px;
        > div {
            position: absolute;
            height: 100%;
            width: 100%;
            bottom: -50px;
        }
    }
    .switch-map {
        position: absolute;
        width: 50px;
        height: 50px;
        top: 50px;
        right: 100px;
        background: url(~@/assets/images/energyMuseum/2d.png);
        background-size: 100% 100%;
        &.map-3d {
            background: url(~@/assets/images/energyMuseum/3d.png);
            background-size: 100% 100%;
        }
    }
    .content {
        position: relative;
        display: flex;
        .map-left, .map-right {
            width: 560px;
            flex-shrink: 0;
        }
        .map-center {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: start;
            margin-top: 20px;
        }
    }
}
</style>